var render, staticRenderFns
import script from "./ordered_layout.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ordered_layout.vue?vue&type=script&lang=js"
export * from "./ordered_layout.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ordered_layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports